'use client';

import { Button } from '@/components/ui/button';

interface BrandCTAProps {
  label: string;
  onClick?: () => void;
  size?: 'default';
  className?: string;
}

export function BrandCTA({ label, onClick, size = 'default', className }: BrandCTAProps) {
  const sizing = size === 'default' ? 'h-10 px-4 text-sm' : 'h-10 px-4 text-sm';

  return (
    <div
      className={`group relative inline-block rounded-[var(--radius-lg)] bg-gradient-to-b from-black/10 to-white/10 p-px backdrop-blur-lg transition-shadow duration-[time:var(--t-spring)] dark:from-white/10 dark:to-black/10 ${className ?? ''}`}
    >
      <Button
        type="button"
        variant="ghost"
        onClick={onClick}
        className={`rounded-[1.05rem] ${sizing} border border-black/10 bg-white/95 font-semibold text-black backdrop-blur-md transition-all duration-[time:var(--t-spring)] hover:bg-white group-hover:-translate-y-0.5 dark:border-white/10 dark:bg-black/95 dark:text-white dark:hover:bg-black dark:hover:shadow-neutral-800/50`}
      >
        <span className="opacity-90 transition-opacity group-hover:opacity-100">{label}</span>
      </Button>
    </div>
  );
}
